const moment = require('moment-timezone');
module.exports = moment.tz.setDefault('Europe/Stockholm');
